var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgArr = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 25,
    viewBox: "0 0 47 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.56 24.296V22c-1.419-.093-2.623-.439-3.612-1.036a9.425 9.425 0 0 1-2.492-2.296l1.652-1.484c.597.803 1.25 1.447 1.96 1.932.728.467 1.568.765 2.52.896v-7.196c-1.923-.43-3.332-1.055-4.228-1.876-.877-.84-1.316-1.988-1.316-3.444 0-.747.13-1.41.392-1.988a4.69 4.69 0 0 1 1.148-1.54A5.31 5.31 0 0 1 4.32 2.96a8.208 8.208 0 0 1 2.24-.504V.16h1.736v2.268c1.27.112 2.361.439 3.276.98.933.523 1.736 1.25 2.408 2.184L12.272 6.88a5.936 5.936 0 0 0-1.68-1.596c-.653-.43-1.428-.71-2.324-.84v6.552l.252.056c1.941.43 3.35 1.064 4.228 1.904.896.821 1.344 1.97 1.344 3.444 0 1.605-.523 2.903-1.568 3.892-1.027.97-2.436 1.54-4.228 1.708v2.296H6.56Zm5.32-7.756c0-.952-.28-1.68-.84-2.184-.541-.504-1.465-.915-2.772-1.232v6.888c1.12-.15 1.997-.523 2.632-1.12.653-.616.98-1.4.98-2.352ZM3.256 7.328c0 .952.27 1.67.812 2.156.56.467 1.4.85 2.52 1.148V4.444c-1.008.13-1.82.439-2.436.924-.597.485-.896 1.139-.896 1.96ZM18.198 22v-2.072h5.46V4.192h-.196l-4.928 4.592L17.162 7.3l5.18-4.844h3.668v17.472h5.04V22H18.198ZM34.904 1.28h2.24v13.132h.111l2.212-2.464 4.089-4.396h2.716l-5.349 5.712L46.803 22h-2.715L39.3 14.636l-2.156 2.212V22h-2.24V1.28Z",
    opacity: 0.3,
    fill: "#000"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgArr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arr.de5638cf222d2d3dfad593f20180fc29.svg";